import { render } from "./SystemCheck.vue?vue&type=template&id=806b72b2"
import script from "./SystemCheck.vue?vue&type=script&lang=js"
export * from "./SystemCheck.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__